'use client'

import { MessageCircle } from 'lucide-react'
import { useTranslations } from 'next-intl'
import { CSSProperties } from 'react'
import { Button } from '@/components/button'
import { cn } from '@/utils/styles/cn'

interface IMoinAiChatPlaceholderProps {
    onActivate: () => void
    className?: string
    style?: CSSProperties
}

export const MoinAiChatPlaceholder = ({
    onActivate,
    className,
    style,
}: IMoinAiChatPlaceholderProps) => {
    const t = useTranslations()

    return (
        <div
            className={cn(
                'flex flex-col items-center justify-center gap-3 bg-gray-100 p-8 text-center',
                className
            )}
            style={style}
        >
            <MessageCircle className="h-10 w-10" />

            <p className="text-lg font-bold">{t('consent.chat.title')}</p>

            <p className="max-w-sm text-sm text-gray-600">{t('consent.chat.description')}</p>

            <Button styleType="primary" shape="pill" onClick={onActivate}>
                {t('consent.chat.button')}
            </Button>
        </div>
    )
}
